// extracted by mini-css-extract-plugin
export var icon = "MenuItemIconOrImage-module--icon--84a4d";
export var image = "MenuItemIconOrImage-module--image--7ef64";
export var svgIcon = "MenuItemIconOrImage-module--svgIcon--4cc16";
export var variantMenu = "MenuItemIconOrImage-module--variant-menu--b237f";
export var variantTrending = "MenuItemIconOrImage-module--variant-trending--e37a5";